(function () {
  function normalize(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9]+/g, " ")
      .trim();
  }

  function compactHandle(value) {
    return normalize(value).replace(/\s+/g, "");
  }

  function getCheckedValues(form, filterName) {
    return Array.prototype.slice.call(form.querySelectorAll("[data-vc-fallback-filter='" + filterName + "']:checked")).map(function (input) {
      return input.value;
    });
  }

  function matchesAnyText(sourceValues, selectedValues) {
    if (!selectedValues.length) return true;

    var normalizedSources = sourceValues.map(function (value) {
      return normalize(value);
    });
    var sourceHandles = sourceValues.map(function (value) {
      return compactHandle(value);
    });

    return selectedValues.some(function (selectedValue) {
      var selected = normalize(selectedValue);
      var selectedHandle = compactHandle(selectedValue);
      if (!selected) return false;

      return normalizedSources.some(function (source, index) {
        var sourceHandle = sourceHandles[index];
        return source === selected || source.indexOf(selected) !== -1 || sourceHandle === selectedHandle || sourceHandle.indexOf(selectedHandle) !== -1;
      });
    });
  }

  function matchesPriceRange(price, selectedRanges) {
    if (!selectedRanges.length) return true;
    if (!Number.isFinite(price)) return false;

    return selectedRanges.some(function (range) {
      switch (range) {
        case "Under $100":
          return price < 10000;
        case "$100 – $200":
        case "$100 - $200":
          return price >= 10000 && price <= 19999;
        case "$200 – $300":
        case "$200 - $300":
          return price >= 20000 && price <= 29999;
        case "$300+":
          return price >= 30000;
        default:
          return true;
      }
    });
  }

  function matchesBrand(vendor, selectedBrands) {
    if (!selectedBrands.length) return true;

    var normalizedVendor = normalize(vendor);
    var vendorHandle = compactHandle(vendor);
    return selectedBrands.some(function (brand) {
      return normalizedVendor === normalize(brand) || vendorHandle === compactHandle(brand);
    });
  }

  function getRenderedCount(countElement) {
    if (!countElement) return null;

    var valueElement = countElement.querySelector("[data-vc-collection-count-value], [data-vc-fallback-apply-count]");
    var count = Number.parseInt(String(valueElement ? valueElement.textContent : countElement.textContent).replace(/[^0-9-]/g, ""), 10);
    return Number.isFinite(count) ? count : null;
  }

  function updateCountText(countElement, count) {
    if (!countElement) return;

    var valueElement = countElement.querySelector("[data-vc-collection-count-value], [data-vc-fallback-apply-count]");
    var itemLabel = countElement.dataset.itemLabel || "ITEM";
    var itemsLabel = countElement.dataset.itemsLabel || "ITEMS";
    var label = count === 1 ? itemLabel : itemsLabel;

    if (valueElement) {
      valueElement.textContent = count;
      var textNode = valueElement.nextSibling && valueElement.nextSibling.nodeType === Node.TEXT_NODE ? valueElement.nextSibling : null;
      if (textNode) {
        textNode.textContent = "\u00a0" + label;
      } else {
        valueElement.parentNode.insertBefore(document.createTextNode("\u00a0" + label), valueElement.nextSibling);
      }
    } else {
      countElement.textContent = count + " " + label;
    }
  }

  function initFallbackFilters(section, setOpen) {
    if (section.dataset.vcFallbackFilters !== "true") return;

    var form = section.querySelector("[data-vc-fallback-filter-form]");
    var productCards = Array.prototype.slice.call(section.querySelectorAll("[data-vc-product-card]"));
    var activeCount = section.querySelector("[data-vc-filter-active-count]");
    var toolbarCount = section.querySelector("[data-vc-collection-count]");
    var applyButton = section.querySelector("[data-vc-fallback-apply]");
    var clearButton = section.querySelector("[data-vc-fallback-clear]");
    var emptyState = section.querySelector("[data-vc-fallback-empty]");
    var pagination = section.querySelector(".vc-collection-pagination, [data-vc-infinite-sentinel]");
    var fallbackTotalCount = getRenderedCount(toolbarCount);

    if (!Number.isFinite(fallbackTotalCount)) {
      fallbackTotalCount = getRenderedCount(applyButton);
    }

    if (!Number.isFinite(fallbackTotalCount)) {
      fallbackTotalCount = productCards.length;
    }

    if (!form || !productCards.length) return;

    function getState() {
      var category = getCheckedValues(form, "category")[0] || "All";
      return {
        category: category,
        brands: getCheckedValues(form, "brand"),
        colors: getCheckedValues(form, "color"),
        prices: getCheckedValues(form, "price")
      };
    }

    function matchesCategory(card, category) {
      if (!category || normalize(category) === "all") return true;

      var tags = String(card.dataset.productTags || "").split("||");
      var type = card.dataset.productType || "";
      return matchesAnyText([type].concat(tags), [category]);
    }

    function applyFilters() {
      var state = getState();
      var visibleCount = 0;
      var activeFilterCount = (state.category && normalize(state.category) !== "all" ? 1 : 0) + state.brands.length + state.colors.length + state.prices.length;

      productCards.forEach(function (card) {
        var tags = String(card.dataset.productTags || "").split("||");
        var vendor = card.dataset.productVendor || "";
        var price = Number.parseInt(card.dataset.productPrice || "", 10);
        var isVisible = matchesCategory(card, state.category) && matchesBrand(vendor, state.brands) && matchesAnyText(tags, state.colors) && matchesPriceRange(price, state.prices);

        card.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      if (activeCount) {
        activeCount.textContent = activeFilterCount;
        activeCount.hidden = activeFilterCount === 0;
      }

      var displayCount = activeFilterCount > 0 ? visibleCount : fallbackTotalCount;

      updateCountText(toolbarCount, displayCount);
      updateCountText(applyButton, displayCount);
      if (emptyState) emptyState.hidden = visibleCount !== 0;
      if (pagination) pagination.hidden = activeFilterCount > 0;
    }

    form.addEventListener("change", applyFilters);
    form.addEventListener("submit", function (event) {
      event.preventDefault();
      applyFilters();
      setOpen(false);
    });

    if (clearButton) {
      clearButton.addEventListener("click", function () {
        Array.prototype.slice.call(form.querySelectorAll("[data-vc-fallback-filter]")).forEach(function (input) {
          if (input.type === "radio") {
            input.checked = normalize(input.value) === "all";
          } else {
            input.checked = false;
          }
        });
        applyFilters();
      });
    }

    applyFilters();
  }

  function initCollectionFilters(root) {
    var scope = root || document;

    scope.querySelectorAll("[data-vc-collection]").forEach(function (section) {
      if (section.dataset.vcCollectionFiltersInitialized === "true") return;
      section.dataset.vcCollectionFiltersInitialized = "true";

      var openButton = section.querySelector("[data-vc-filter-open]");
      var drawer = section.querySelector("[data-vc-filter-drawer]");
      var panel = section.querySelector("[data-vc-filter-panel]");
      if (!openButton || !drawer || !panel) return;

      var closeButtons = Array.prototype.slice.call(section.querySelectorAll("[data-vc-filter-close]"));
      var focusableSelector = "a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex='-1'])";

      function setOpen(isOpen) {
        drawer.hidden = !isOpen;
        openButton.setAttribute("aria-expanded", String(isOpen));

        if (isOpen) {
          panel.focus();
          document.addEventListener("keydown", handleKeydown);
        } else {
          document.removeEventListener("keydown", handleKeydown);
          openButton.focus();
        }
      }

      function handleKeydown(event) {
        if (event.key === "Escape") {
          setOpen(false);
          return;
        }

        if (event.key !== "Tab") return;

        var focusableItems = Array.prototype.slice.call(panel.querySelectorAll(focusableSelector)).filter(function (item) {
          return item.offsetParent !== null;
        });
        if (!focusableItems.length) return;

        var firstItem = focusableItems[0];
        var lastItem = focusableItems[focusableItems.length - 1];

        if (event.shiftKey && document.activeElement === firstItem) {
          event.preventDefault();
          lastItem.focus();
        } else if (!event.shiftKey && document.activeElement === lastItem) {
          event.preventDefault();
          firstItem.focus();
        }
      }

      openButton.addEventListener("click", function () {
        setOpen(true);
      });

      closeButtons.forEach(function (button) {
        button.addEventListener("click", function () {
          setOpen(false);
        });
      });

      initFallbackFilters(section, setOpen);
    });
  }

  function initCollectionSorts(root) {
    var scope = root || document;

    scope.querySelectorAll("[data-vc-sort-form]").forEach(function (form) {
      if (form.dataset.vcSortInitialized === "true") return;
      form.dataset.vcSortInitialized = "true";
      form.classList.add("is-enhanced");

      var select = form.querySelector("[data-vc-sort-select]");
      if (!select) return;

      select.addEventListener("change", function () {
        if (typeof form.requestSubmit === "function") {
          form.requestSubmit();
        } else {
          form.submit();
        }
      });
    });
  }

  function initInfiniteScroll(scope) {
    var root = scope || document;
    var sections = root.querySelectorAll ? root.querySelectorAll("[data-vc-collection]") : [];

    Array.prototype.forEach.call(sections, function (section) {
      if (section.dataset.vcInfiniteInitialized === "true") return;

      var sentinel = section.querySelector("[data-vc-infinite-sentinel]");
      var list = section.querySelector("[data-vc-collection-items]");
      var status = section.querySelector("[data-vc-collection-status]");
      if (!sentinel || !list) return;

      section.dataset.vcInfiniteInitialized = "true";

      var sectionId = section.dataset.sectionId;
      var spinner = sentinel.querySelector(".vc-collection-infinite__spinner");
      var link = sentinel.querySelector("[data-vc-infinite-link]");
      var fallbackHash = link && link.href ? new URL(link.href, window.location.href).hash : "";
      var loading = false;
      var observer = null;
      var preloadDistance = 600;
      var seenProductIds = new Set();

      Array.prototype.forEach.call(list.querySelectorAll("[data-vc-product-id]"), function (item) {
        if (item.dataset.vcProductId) seenProductIds.add(item.dataset.vcProductId);
      });

      function setStatus(message) {
        if (status) status.textContent = message || "";
      }

      function setLoading(isLoading) {
        loading = isLoading;
        sentinel.setAttribute("aria-busy", String(isLoading));
        if (spinner) spinner.hidden = !isLoading;
      }

      function buildFetchUrl(nextUrl) {
        var url = new URL(nextUrl, window.location.href);
        if (sectionId) url.searchParams.set("section_id", sectionId);
        return url.toString();
      }

      function buildPageUrl(nextUrl) {
        var url = new URL(nextUrl, window.location.href);
        url.searchParams.delete("section_id");
        url.hash = "";
        return url.pathname + url.search + url.hash;
      }

      var listingCount = section.querySelector("[data-vc-listing-count]");
      var listingEmpty = section.querySelector("[data-vc-listing-empty]");
      var visibleCount = listingCount ? Number(listingCount.dataset.count) : 0;

      function updateListingCount(added) {
        visibleCount += added;
        if (listingCount) listingCount.textContent = section.dataset.countMessage.replace("__count__", String(visibleCount));
      }

      function finish() {
        if (listingEmpty) listingEmpty.hidden = visibleCount > 0;
        if (observer) observer.disconnect();
        sentinel.remove();
        setStatus(section.dataset.completeMessage);
      }

      function handleFailure(navigateOnError) {
        setLoading(false);
        if (observer) observer.disconnect();
        if (link) link.hidden = false;
        setStatus(section.dataset.errorMessage);

        if (navigateOnError && link && link.href) {
          window.location.assign(link.href);
        }
      }

      function continueIfPaginationIsNearViewport(navigateOnError) {
        window.requestAnimationFrame(function () {
          var bounds = sentinel.getBoundingClientRect();
          var isNearViewport = bounds.top <= window.innerHeight + preloadDistance && bounds.bottom >= -preloadDistance;
          if (isNearViewport) loadNextPage(navigateOnError);
        });
      }

      function loadNextPage(navigateOnError) {
        if (loading) return;
        var nextUrl = sentinel.dataset.nextUrl;
        if (!nextUrl) {
          finish();
          return;
        }

        setLoading(true);
        setStatus(section.dataset.loadingMessage);

        fetch(buildFetchUrl(nextUrl))
          .then(function (response) {
            if (!response.ok) throw new Error("Collection pagination request failed");
            return response.text();
          })
          .then(function (html) {
            var nextDocument = new DOMParser().parseFromString(html, "text/html");
            var newItems = nextDocument.querySelectorAll("[data-vc-collection-items] > [data-vc-product-id]");
            if (!nextDocument.querySelector("[data-vc-collection-items]")) throw new Error("Collection pagination returned no grid");

            var fragment = document.createDocumentFragment();
            var appendedItemCount = 0;

            Array.prototype.forEach.call(newItems, function (item) {
              var productId = item.dataset.vcProductId;
              if (productId && seenProductIds.has(productId)) return;
              if (productId) seenProductIds.add(productId);
              fragment.appendChild(document.importNode(item, true));
              appendedItemCount += 1;
            });
            list.appendChild(fragment);

            updateListingCount(appendedItemCount);
            if (appendedItemCount > 0) {
              document.dispatchEvent(new CustomEvent("vita:content:loaded", {
                detail: {
                  container: list
                }
              }));
            }

            var nextSentinel = nextDocument.querySelector("[data-vc-infinite-sentinel]");
            if (!nextSentinel || !nextSentinel.dataset.nextUrl) {
              finish();
              return;
            }

            var nextPageUrl = buildPageUrl(nextSentinel.dataset.nextUrl);
            sentinel.dataset.nextUrl = nextPageUrl;
            if (link) link.href = nextPageUrl + fallbackHash;
            setLoading(false);
            setStatus(section.dataset.loadedMessage);
            continueIfPaginationIsNearViewport(navigateOnError);
          })
          .catch(function () {
            handleFailure(navigateOnError);
          });
      }

      if (link) {
        link.addEventListener("click", function (event) {
          event.preventDefault();
          loadNextPage(true);
        });
      }

      if ("IntersectionObserver" in window) {
        try {
          observer = new IntersectionObserver(function (entries) {
            if (entries.some(function (entry) { return entry.isIntersecting; })) {
              loadNextPage(false);
            }
          }, {
            rootMargin: preloadDistance + "px 0px"
          });
          observer.observe(sentinel);
          if (link) link.hidden = true;
        } catch (error) {
          if (observer) observer.disconnect();
          observer = null;
          if (link) link.hidden = false;
        }
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initCollectionFilters(document);
    initCollectionSorts(document);
    initInfiniteScroll(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initCollectionFilters(event.target);
    initCollectionSorts(event.target);
    initInfiniteScroll(event.target);
  });
})();
